export const OCC_ENDPOINTS = {
  search: '/geo/search_city',
  defineBaseStore: '/geo/define_base_store',
  baseStores: '/basestores',
};
